import type { LocationQueryRaw, RouteLocationNormalized } from "#vue-router";
import { AuthPages } from "~/auth/types/auth";

export default defineNuxtPlugin(() => {
  const user = useUser();

  function navigateToAuthPage(authPath: AuthPages, route: RouteLocationNormalized, queryParams?: LocationQueryRaw) {
    if (route.path === authPath) {
      return Promise.resolve();
    }
    return navigateTo({ path: authPath, query: { ...queryParams, redirectUrl: route.fullPath } });
  }

  addRouteMiddleware(
    "auth",
    (to) => {
      const isLoggedIn = Boolean(user.value);
      const isGuest = !isLoggedIn;
      const isGuestAllowed = to.meta.layout === "auth" || to.meta.allow_guest;

      // Allow access for guests with accessToken and playlistId (shared content)
      if (isGuest && to.query.playlistId && to.query.accessToken) {
        return navigateToAuthPage(AuthPages.SIGN_UP, to, to.query);
      }

      if (isGuest && !isGuestAllowed && to.query.playlistId) {
        return navigateToAuthPage(AuthPages.LOGIN, to, { playlistPermissionError: "true" });
      }

      if (isGuest && !isGuestAllowed) {
        return navigateToAuthPage(AuthPages.LOGIN, to);
      }
    },
    { global: true }
  );
});
